import styles from "../../ModalCriarRota/ModalCriarRota.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../../components/Grid";
import {
  customStyles,
  SelectSearch,
} from "../../../../../components/components-ui/SelectSearch/SelectSearch";
import api from "../../../../../services/Api";
import { useContext, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Select from "react-select";
import { Table } from "../../../../../components/Table";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import Loading from "../../../../../components/components-ui/Loading/Loading";
import Modal from "@mui/material/Modal";
import ModalNaoTemOleo from "../ModalNaoTemOleo/ModalNaoTemOleo";
import CustomConfirmAlert from "../../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";
import { AuthContext } from "../../../../../Provider/AuthContext";

const API_TIPO_PAGAMENTO = "/painelfreguesia/listatipopagamento";
const API_LOCAL = "/freguesia/listalocalfreguesia?nome_local=";
const API_LISTA_EMISSOR = `/usuario/view`;
const API_CONTRAPARTIDA = `/brinde/index`;
const API_DADOS_NOVA_COLETA = `/coleta/new`;
const API_CREATE_COLETA = "/freguesia/criarcoletafreguesia";
const API_SHOW_COLETA = "/coleta/show/";
const API_EDIT_COLETA = "/freguesia/editarcoletafreguesia/";
const API_DESVINCULAR_COLETA = "/freguesia/desvincularcoleta";
const API_EXCLUIR_COLETA = "/freguesia/excluircoleta";
const API_DESFAZER_NAO_TEM_OLEO = "/freguesia/desfazernaotemoleo";

const columnsProdutos = [
  {
    column: "Produto",
  },
  {
    column: "Qtde.",
  },
  {
    column: "Total Litros",
  },
  {
    column: "Brinde.",
  },
];

function AdicionarColeta({
  idColeta,
  idLocal,
  nomeLocal,
  idOCSub,
  idOc,
  back,
  closeModal,
  freguesia,
  carregarLocaisDaRota,
  infosCriarColeta,
  valorKg,
}) {
  const { idTipoUsuario } = useContext(AuthContext);
  const [dadosColeta, setDadosColeta] = useState([]);
  const [dadosListaColetaSub, setDadosListaColetaSub] = useState([]);
  const [tiposPagamento, setTiposPagamento] = useState([]);
  const [emissor, setEmissor] = useState([]);
  const [locais, setLocais] = useState([]);
  const [dadosNovaColeta, setDadosNovaColeta] = useState([]);
  const [itensContrapartida, setItensContrapartida] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [inputLocal, setInputLocal] = useState("");
  const [loading, setLoading] = useState(false);
  const [openModalOleo, setOpenModalOleo] = useState(false);
  const [permissaoNaoTemOleo, setPermissaoNaoTemOleo] = useState(null);

  const ref = useRef(null);

  // const getLocal = async (input) => {
  //   setLoading(true);
  //   await api
  //     .get(API_LOCAL + input)
  //     .then((res) => {
  //       setLocais(res.data.data);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log(error);
  //     });
  // };

  const verificaPermissao = async (idPerfil, idAcao) => {
    try {
      const response = await api.get(`/permissao/${idPerfil}/${idAcao}`);
      setPermissaoNaoTemOleo(response.data.permissao);
    } catch (error) {
      console.error("Erro ao verificar permissão:", error);
    }
  };

  const getDadosColeta = async () => {
    setLoading(true);
    const response = await api.get(API_SHOW_COLETA + idColeta);
    setDadosColeta(response.data.coleta);
    setDadosListaColetaSub(response.data.coleta_sub);
    setProdutos(response.data.coleta_contrapartida);
    setLoading(false);
  };

  const getTiposPagamento = async () => {
    await api
      .get(API_TIPO_PAGAMENTO)
      .then((res) => setTiposPagamento(res.data))
      .catch((error) => console.log(error));
  };

  const getEmissor = async () => {
    await api
      .get(API_LISTA_EMISSOR)
      .then((res) => setEmissor(res.data))
      .catch((error) => console.log(error));
  };

  // Carregar itens do select produtos
  const getItensProdutos = async () => {
    await api
      .get(API_CONTRAPARTIDA)
      .then((res) => setItensContrapartida(res.data))
      .catch((error) => console.log(error));
  };

  // Dados Pra nova coleta
  const getDadosNovaColeta = async () => {
    await api
      .get(API_DADOS_NOVA_COLETA)
      .then((res) => setDadosNovaColeta(res.data))
      .catch((error) => console.log(error));
  };

  //Carregar selects tiposPagamento
  useEffect(() => {
    if (idColeta) {
      getDadosColeta();
      verificaPermissao(idTipoUsuario, 88); // Verifica se tem permissão para desfazer nao tem oleo
    }
    getDadosNovaColeta();
    getTiposPagamento();
    getEmissor();
    getItensProdutos();
  }, []);

  //Buscar locais ao digitar
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (inputLocal.length) {
  //       getLocal(inputLocal);
  //     } else {
  //       setLocais([]);
  //     }
  //   }, 500);
  // }, [inputLocal]);

  async function criarColeta(values) {
    const dados = {
      IDLocal: idLocal,
      DataCriacao: values?.dataCriacao,
      DataPedido: values?.dataPedido,
      IdColetasOc: idOc,
      IDCriadoPor: values?.usuarioCriacao,
      Audi_IDUsuario_Criacao: values?.usuarioCriacao,
      Audi_Data_Criacao: values?.dataCriacao,
      IdTipoColeta: values?.tipoColeta,
      IdFormaPagamento: values?.tipoPagamento,
      ValorPagamento: values?.valor || null,
      NumeroPedido: values?.numeroPedido,
      ColetaRecado: false,
      Observacoes: values?.observacao,
    };

    const data = {
      ...dados,
      coletasub: [{ IDItem: 1, Quantidade: values?.quantidade }],
      contraPartida: produtos,
    };

    await api
      .post(API_CREATE_COLETA, data)
      .then((response) => {
        if (response.data?.error === 0) {
          toast.success(response.data?.msg, {
            position: "bottom-right",
            autoClose: 2500,
          });
          carregarLocaisDaRota(
            idOc,
            freguesia,
            infosCriarColeta.status,
            infosCriarColeta.infos
          );
          closeModal();
        } else if (response.data?.error === 1) {
          toast.warn(response.data.msg);
        }
      })
      .catch((e) => {
        toast.error("Algo de errado aconteceu: " + e.message);
        console.log(e);
      });
  }

  async function editarColeta(idColeta, values) {
    const dados = {
      IDLocal: values?.local.value,
      Audi_IDUsuario_Alteracao: dadosNovaColeta?.user_id,
      Audi_Data_Alteracao: values?.dataAlteracao,
      IdFormaPagamento: values?.tipoPagamento,
      ValorPagamento: values?.valor || null,
      NumeroPedido: values?.numeroPedido,
      CodigoDaFreguesia: values?.freguesia,
      DiaRetirada: values?.dia,
      ColetaRecado: values?.recado,
      Observacoes: values?.observacao,
    };

    const data = {
      ...dados,
      coletasub: [
        {
          IDColetaSub: dadosListaColetaSub[0]?.IDColetaSub,
          Quantidade: values?.quantidade,
        },
      ],
    };

    await api
      .put(API_EDIT_COLETA + idColeta, data)
      .then((response) => {
        if (response.data?.error === 0) {
          toast.success(response.data?.msg, {
            position: "bottom-right",
            autoClose: 2500,
          });
          carregarLocaisDaRota(
            idOc,
            freguesia,
            infosCriarColeta.status,
            infosCriarColeta.infos
          );
          closeModal();
        }
      })
      .catch((e) => {
        toast.error("Algo de errado aconteceu: " + e.message);
        console.log(e);
      });
  }

  function adicionaProduto(values, setFieldValue) {
    const infos = itensContrapartida.find(
      (item) => item.id_brinde === values?.produto?.value
    );

    const item = {
      IDBrinde: values?.produto?.value,
      Brinde: values?.produto?.label,
      QuantidadeSolicitada: values?.qtdProduto,
      Bonificacao: values?.brinde,
      ValorUnitario: infos?.ValorVenda,
      ValorTotal: infos?.ValorVenda * Number(values?.qtdProduto),
      VolumeUnitario: infos?.VolumeUnitario,
      VolumeTotal: infos?.VolumeTotal * Number(values?.qtdProduto),
    };

    if (!values?.produto?.value) {
      toast.error("Selecione uma opção de produto");
      return;
    }

    // Verificar se a quantidade está correta
    if (
      !values?.qtdProduto ||
      !values?.qtdProduto === "" ||
      values?.qtdProduto <= 0
    ) {
      toast.error("Insira uma quantidade válida");
      return;
    }

    // Verificar se o item já foi adicionado
    const verificaItem = produtos.find(
      (item) => item.IDBrinde === values?.produto?.value
    );

    if (verificaItem) {
      toast.error(
        "Item já existente! Se deseja alterar a quantidade exclua e adicione novamente."
      );
      return;
    }

    // Verifica se esta na tela de edição, caso esteja adiciona a contrapartida direto no banco
    if (idColeta) {
      api
        .post(`/coleta/contrapartida/${idColeta}`, item)
        .then((res) => {
          setProdutos([
            ...produtos,
            { IDContrapartida: res.data.IDContrapartida, ...item },
          ]);
          toast.success(res.data.msg, { autoClose: 2000 });
        })
        .catch(() => toast.error("Algo de errado aconteceu ao adicionar"));
    } else {
      setProdutos([...produtos, item]);
    }

    setFieldValue("produto", { value: null, label: "Selecione" });
    setFieldValue("qtdProduto", "");
    setFieldValue("totalLitros", "");
    setFieldValue("brinde", false);
  }

  function removeProduto(value) {
    // Verifica se está na rota de edição, caso esteja deleta o item no banco
    if (idColeta) {
      api
        .delete(`/coleta/contrapartida/${idColeta}/${value?.IDContrapartida}`)
        .then((res) => {
          const itens = produtos.filter(
            (item) => item.IDContrapartida !== value?.IDContrapartida
          );
          setProdutos([...itens]);
          toast.success(res.data.msg, { autoClose: 2000 });
        })
        .catch((error) => toast.error(error));
    } else {
      const itens = produtos.filter(
        (item) => item.IDBrinde !== value?.IDBrinde
      );
      setProdutos([...itens]);
    }
  }

  const handleChangeProduto = (selectedOption, setFieldValue) => {
    setFieldValue("qtdProduto", "");
    setFieldValue("totalLitros", "");
    setFieldValue("brinde", false);
    setFieldValue("produto", selectedOption); //Seta o valor do select contrapartida como objeto contendo {value: , label: }
  };

  const desvincularColeta = async () => {
    CustomConfirmAlert({
      subtitle: "Tem certeza que deseja desvincular a rota?",
      labelBtnConfirmar: "Desvincular",
      colorBtnConfirmar: "#f44336f7",
      onConfirm: async () => {
        const promise = api.post(API_DESVINCULAR_COLETA, { idColeta });

        toast.promise(promise, {
          pending: "Desvinculando rota...",
          success: {
            render({ data }) {
              const res = data.data;
              if (res.error === 0) {
                return res.msg || "Rota desvinculada com sucesso!";
              }
              throw new Error(res.msg || `Erro: ${res.error}`);
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao desvincular rota";
            },
          },
        });

        try {
          const response = await promise;
          const res = response.data;
          if (res.error === 0) {
            closeModal();
            carregarLocaisDaRota(
              idOc,
              freguesia,
              infosCriarColeta.status,
              infosCriarColeta.infos
            );
          }
        } catch (error) {
          console.error("Erro ao desvincular rota: ", error);
        }
      },
    });
  };

  const excluirColeta = async () => {
    CustomConfirmAlert({
      subtitle: "Tem certeza que deseja excluir a coleta?",
      labelBtnConfirmar: "Excluir",
      colorBtnConfirmar: "#f44336f7",
      onConfirm: async () => {
        const promise = api.post(API_EXCLUIR_COLETA, { idColeta });

        toast.promise(promise, {
          pending: "Excluindo Coleta...",
          success: {
            render({ data }) {
              const res = data.data;
              if (res.error === 0) {
                return res.msg || "Coleta Excluida com sucesso!";
              }
              throw new Error(res.msg || `Erro: ${res.error}`);
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao excluir a coleta";
            },
          },
        });

        try {
          const response = await promise;
          const res = response.data;
          if (res.error === 0) {
            closeModal();
            carregarLocaisDaRota(
              idOc,
              freguesia,
              infosCriarColeta.status,
              infosCriarColeta.infos
            );
          }
        } catch (error) {
          console.error("Erro ao excluir a coleta: ", error);
        }
      },
    });
  };

  const desfazerNaoTemOleo = () => {
    const data = {
      idColeta: idColeta,
      idOc: idOc,
    };

    CustomConfirmAlert({
      subtitle: "Tem certeza que deseja desfazer o Não Tem Óleo?",
      labelBtnConfirmar: "Desfazer",
      colorBtnConfirmar: "#f44336f7",
      onConfirm: async () => {
        const promise = api.post(API_DESFAZER_NAO_TEM_OLEO, data);

        try {
          toast.loading("Carregando...");
          const response = await promise;
          const res = response.data;
          toast.dismiss();
          if (res.error === 0) {
            closeModal();
            carregarLocaisDaRota(
              idOc,
              freguesia,
              infosCriarColeta.status,
              infosCriarColeta.infos
            );
            toast.success(res.msg);
          } else {
            toast.warn(res.msg);
          }
        } catch (error) {
          console.error("Erro ao desvincular rota: ", error);
        }
      },
    });
  };

  const handleChangePagamento = (selectedOption, setFieldValue, values) => {
    setFieldValue("tipoPagamento", selectedOption?.value);

    if (selectedOption.value === 6 || selectedOption.value === 2) {
      if (!valorKg) {
        setFieldValue("valor", null);
        toast.warn(
          "Não está cadastrado o valor da contrapartida por Kg para o local"
        );
        return;
      }
      setFieldValue("valor", (valorKg * values.quantidade).toFixed(2));
    } else {
      setFieldValue("valor", "");
    }
  };

  const onLostFocus = (setFieldValue, values) => {
    if (values.tipoPagamento === 6 || values.tipoPagamento === 2) {
      if (!valorKg) {
        setFieldValue("valor", null);
        toast.warn(
          "Não está cadastrado o valor da contrapartida por Kg para o local"
        );
        return;
      }
      setFieldValue("valor", (valorKg * values.quantidade).toFixed(2));
    } else {
      setFieldValue("valor", "");
    }
  };

  const validationSchema = Yup.object().shape({
    tipoPagamento: Yup.string().nullable().required("Campo Obrigatório"),
    quantidade: Yup.number()
      .min(0, "Insira um numero positivo")
      .nullable()
      .required("Campo Obrigatório"),
    valor: Yup.number().min(0.01, "Insira uma quantidade válida").nullable(),
  });

  return (
    <div className={styles.modal_container}>
      <h2 style={{ textAlign: "center" }}>
        {idColeta
          ? `Edição de Coleta N°${idColeta} (${freguesia})`
          : `Criação de Coleta O.C. N°${idOc} (${freguesia})`}
      </h2>
      <Formik
        initialValues={{
          numeroPedido: idColeta ? dadosColeta?.NumeroPedido : null,
          local: idColeta
            ? {
                value: dadosColeta?.IDLocal,
                label: `(${dadosColeta?.IDLocal}) - ${dadosColeta?.marca}`,
              }
            : idLocal,
          dataPedido: idColeta
            ? dadosColeta?.DataPedido
            : dadosNovaColeta?.data_pedido,
          tipoPagamento: idColeta ? dadosColeta?.IdFormaPagamento : null,
          quantidade: dadosListaColetaSub[0]?.estimativa_ligacao || null,
          observacao: idColeta ? dadosColeta?.observacao : "",
          valor: idColeta ? dadosColeta?.ValorPagamento?.toFixed(2) : null,
          recado: idColeta ? Boolean(dadosColeta?.ColetaRecado) : false,
          brinde: false,
          naoTemOleo: dadosColeta?.NaoTemOleo || 0,
          naoTemOleoCriadoPor: dadosColeta?.NaoTemOleoIdUsuario || null,
          dataNaoTemOleo: dadosColeta?.NaoTemOleoData || null,
          observacaoNaoTemOleo: dadosColeta?.NaoTemOleoObservacao || "",
          emissor: idColeta
            ? dadosColeta?.Audi_IDUsuario_Criacao
            : dadosNovaColeta?.user_id,
          dataCriacao: idColeta
            ? dadosColeta?.Audi_Data_Criacao
            : dadosNovaColeta?.data_pedido,
          usuarioCriacao: idColeta
            ? dadosColeta?.Audi_IDUsuario_Criacao
            : dadosNovaColeta?.user_id,
        }}
        validationSchema={validationSchema}
        enableReinitialize={true}
        validateOnBlur
        validateOnChange
        onSubmit={(values) =>
          idColeta ? editarColeta(idColeta, values) : criarColeta(values)
        }
      >
        {({ errors, touched, values, isSubmitting, isValid, setFieldValue }) =>
          loading ? (
            <div className={styles.loading_container}>
              <Loading />
            </div>
          ) : (
            <Form>
              {/* Modal Criar Rota */}
              <div>
                <Grid>
                  <Col size={2}>
                    <label>N° Pedido</label>
                    <Field type="text" name="numeroPedido" disabled />
                    {errors.numeroPedido && touched.numeroPedido ? (
                      <span className={styles.alertError}>
                        {errors.numeroPedido}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={10} style={{ alignSelf: "end" }}>
                    <label>Local</label>
                    <Field name="local">
                      {({ ...field }) => (
                        <Select
                          {...field}
                          value={
                            idColeta
                              ? values.local
                              : { value: idLocal, label: nomeLocal }
                          }
                          // value={values.local}
                          options={locais.map((values) => ({
                            label: values?.NomeLocal,
                            value: values?.IdLocal,
                          }))}
                          styles={customStyles}
                          placeholder="Digite..."
                          noOptionsMessage={() =>
                            !inputLocal.length
                              ? "Digite parte do nome"
                              : "Nenhuma opção encontrada"
                          }
                          onChange={(selectedOption) =>
                            setFieldValue("local", selectedOption)
                          }
                          onInputChange={(e) => setInputLocal(e)}
                          isClearable
                          isDisabled
                        />
                      )}
                    </Field>
                    {errors.local && touched.local ? (
                      <span className={styles.alertError}>{errors.local}</span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  {/* <Col size={2}>
                    <label>Data Pedido</label>
                    <Field type="date" name="dataPedido" disabled />
                    {errors.dataPedido && touched.dataPedido ? (
                      <span className={styles.alertError}>
                        {errors.dataPedido}
                      </span>
                    ) : null}
                  </Col> */}
                  <Col size={5}>
                    <label> Emissor </label>
                    <Field
                      component={SelectSearch}
                      name="emissor"
                      options={emissor.map((values) => ({
                        label: values?.nome_usuario,
                        value: values?.id_usuario,
                      }))}
                      disabled
                    />
                    {errors.emissor && touched.emissor ? (
                      <span className={styles.alertError}>
                        {errors.emissor}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={1}>
                    <label>Recado?</label>
                    <Field name="recado">
                      {({ field }) => (
                        <input
                          type="checkbox"
                          disabled
                          checked={field.value}
                          {...field}
                        />
                      )}
                    </Field>
                  </Col>
                </Grid>
                <Grid>
                  <Col size={4}>
                    <label>Forma de Pagamento</label>
                    <Field name="tipoPagamento">
                      {({ field }) => {
                        const selectedOption = tiposPagamento.find(
                          (opt) => opt.Id === values.tipoPagamento
                        );

                        return (
                          <Select
                            {...field}
                            onChange={(selectedOption) =>
                              handleChangePagamento(
                                selectedOption,
                                setFieldValue,
                                values
                              )
                            }
                            value={
                              selectedOption
                                ? {
                                    label: selectedOption.TipoPagamento,
                                    value: selectedOption.Id,
                                  }
                                : null
                            }
                            options={tiposPagamento.map((values) => ({
                              label: values?.TipoPagamento,
                              value: values?.Id,
                            }))}
                            styles={customStyles}
                            placeholder="Digite..."
                          />
                        );
                      }}
                    </Field>
                    {errors.tipoPagamento && touched.tipoPagamento ? (
                      <span className={styles.alertError}>
                        {errors.tipoPagamento}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={1}>
                    <label>QTDE</label>
                    <Field
                      type="number"
                      name="quantidade"
                      innerRef={ref}
                      onBlur={() => onLostFocus(setFieldValue, values)}
                    />
                    {errors.quantidade && touched.quantidade ? (
                      <span className={styles.alertError}>
                        {errors.quantidade}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={1}>
                    <label>Valor</label>
                    <Field type="number" name="valor" step="any" />
                    {errors.valor && touched.valor ? (
                      <span className={styles.alertError}>{errors.valor}</span>
                    ) : null}
                  </Col>
                </Grid>

                <Grid>
                  <Col size={12}>
                    <label>Produtos</label>
                    <Box border={1} padding={2}>
                      <Grid>
                        <Col size={5}>
                          <label> Produto </label>
                          <Field name="produto">
                            {({ field }) => (
                              <Select
                                {...field}
                                onChange={(selectedOption) =>
                                  handleChangeProduto(
                                    selectedOption,
                                    setFieldValue
                                  )
                                }
                                options={itensContrapartida.map((values) => ({
                                  value: values?.id_brinde,
                                  label: values?.brinde,
                                }))}
                                placeholder="Selecione"
                                styles={customStyles}
                                isClearable
                                isDisabled={idColeta && dadosColeta?.NaoTemOleo}
                                menuPortalTarget={document.body}
                              />
                            )}
                          </Field>
                          {errors.produto && touched.produto ? (
                            <span className={styles.alertError}>
                              {errors.produto}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label>Quantidade</label>
                          <Field name="qtdProduto">
                            {({ field }) => (
                              <input
                                type="number"
                                step="1"
                                {...field}
                                disabled={
                                  !values.produto?.value ||
                                  (idColeta && dadosColeta?.NaoTemOleo)
                                }
                              />
                            )}
                          </Field>
                          {errors.qtdProduto && touched.qtdProduto ? (
                            <span className={styles.alertError}>
                              {errors.qtdProduto}
                            </span>
                          ) : null}
                        </Col>
                        {/* <Col size={2}>
                          <label>Total Litros</label>
                          <Field name="totalLitros">
                            {({ field }) => (
                              <input
                                type="number"
                                step="1"
                                {...field}
                                disabled
                              />
                            )}
                          </Field>
                          {errors.TLts && touched.TLts ? (
                            <span className={styles.alertError}>
                              {errors.TLts}
                            </span>
                          ) : null}
                        </Col> */}
                        <Col size={3}>
                          <label>Brinde?</label>
                          <Field
                            type="checkbox"
                            name="brinde"
                            disabled={idColeta && dadosColeta?.NaoTemOleo}
                          />
                        </Col>
                        <Col size={2}>
                          <Field name="btnContrapartida">
                            {({ field }) => (
                              <Button
                                onClick={() =>
                                  adicionaProduto(values, setFieldValue)
                                }
                                type="button"
                                title="Adicionar"
                                disabled={idColeta && dadosColeta?.NaoTemOleo}
                              />
                            )}
                          </Field>
                        </Col>
                      </Grid>
                      {/* Produtos */}
                      {produtos.length ? (
                        <Grid>
                          <Col size={12}>
                            <Table
                              edit={!dadosColeta?.NaoTemOleo}
                              columns={columnsProdutos}
                              title="Produtos"
                            >
                              {produtos.map((item, index) => (
                                <tr key={index}>
                                  {!dadosColeta?.NaoTemOleo && (
                                    <td
                                      onClick={() => removeProduto(item)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className="fas fa-trash-alt"></i>
                                    </td>
                                  )}
                                  <td> {item?.Brinde} </td>
                                  <td> {item?.QuantidadeSolicitada} </td>
                                  <td> {item?.VolumeTotal} </td>
                                  <td>
                                    {item?.Bonificacao
                                      ? "Com Brinde"
                                      : "Sem Brinde"}
                                  </td>
                                </tr>
                              ))}
                            </Table>
                            {produtos.length === 0 ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginBottom: "12px",
                                }}
                              >
                                Nenhuma contrapartida adicionada
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Grid>
                      ) : null}
                    </Box>
                  </Col>
                </Grid>
                {idColeta && dadosColeta?.NaoTemOleo ? (
                  <Grid>
                    <Col size={12}>
                      <Box border={1} padding={2} marginBottom={1}>
                        <Grid>
                          <Field type="checkbox" name="naoTemOleo" disabled />
                          <label style={{ marginLeft: "1rem" }}>
                            Não tem óleo
                          </label>
                        </Grid>
                        <Grid>
                          <Col size={6}>
                            <label> Não tem óleo criado por: </label>
                            <Field
                              component={SelectSearch}
                              name="naoTemOleoCriadoPor"
                              options={emissor.map((values) => ({
                                label: values?.nome_usuario,
                                value: values?.id_usuario,
                              }))}
                              disabled
                            />
                            {errors.naoTemOleoCriadoPor &&
                            touched.naoTemOleoCriadoPor ? (
                              <span className={styles.alertError}>
                                {errors.naoTemOleoCriadoPor}
                              </span>
                            ) : null}
                          </Col>
                          <Col size={3}>
                            <label>Data não tem óleo</label>
                            <Field name="dataNaoTemOleo">
                              {({ field }) => (
                                <input
                                  type="datetime-local"
                                  {...field}
                                  disabled
                                />
                              )}
                            </Field>
                          </Col>
                        </Grid>
                        <Grid>
                          <Col size={12}>
                            <label>Observações Não Tem Óleo</label>
                            <Field
                              component="textarea"
                              name="observacaoNaoTemOleo"
                              className={styles.input_style}
                              disabled
                            />
                          </Col>
                        </Grid>
                      </Box>
                    </Col>
                  </Grid>
                ) : null}
                <Grid>
                  <Col size={12}>
                    <label>Observações</label>
                    <Field
                      type="textarea"
                      name="observacao"
                      style={{ height: "50px" }}
                    />
                    {errors.observacao && touched.observacao ? (
                      <span className={styles.alertError}>
                        {errors.observacao}
                      </span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={3}>
                    <label> Usuário Criação </label>
                    <Field
                      component={SelectSearch}
                      name="usuarioCriacao"
                      options={emissor.map((values) => ({
                        value: values?.id_usuario,
                        label: values?.nome_usuario,
                      }))}
                      disabled
                    />
                  </Col>
                  <Col size={3}>
                    <label>Data de Criação</label>
                    <Field name="dataCriacao">
                      {({ field }) => (
                        <input
                          type="datetime-local"
                          {...field}
                          value={field.value?.slice(0, 16)}
                          disabled
                        />
                      )}
                    </Field>
                  </Col>
                </Grid>
                <div className={styles.buttons_container}>
                  {!dadosColeta?.NaoTemOleo && (
                    <Button
                      title="Salvar"
                      type="submit"
                      disabled={isSubmitting}
                      className={styles.button_sm}
                    />
                  )}
                  {idColeta && !dadosColeta?.NaoTemOleo && (
                    <>
                      <Button
                        type="button"
                        onClick={() => desvincularColeta()}
                        disabled={isSubmitting}
                        color={"violet"}
                        className={styles.button_sm}
                      >
                        Desvincular Coleta
                        <i
                          class="fas fa-exclamation-triangle"
                          style={{ color: "white", marginLeft: "10px" }}
                        ></i>
                      </Button>
                      <Button
                        type="button"
                        onClick={() => excluirColeta()}
                        disabled={isSubmitting}
                        color={"tertiary"}
                        className={styles.button_sm}
                      >
                        Excluir Coleta
                        <i
                          class="fas fa-times-circle"
                          style={{ color: "white", marginLeft: "10px" }}
                        ></i>
                      </Button>
                      <Button
                        type="button"
                        disabled={isSubmitting}
                        onClick={() => setOpenModalOleo(true)}
                        color={"tertiary"}
                        className={styles.button_sm}
                      >
                        Não tem Óleo
                        <i
                          class="fas fa-check-circle"
                          style={{ color: "white", marginLeft: "10px" }}
                        ></i>
                      </Button>
                    </>
                  )}
                  {/* Se tem id da coleta e ela não tem óleo e usuário tem permissão, exibe o botao de desfazer */}
                  {idColeta && dadosColeta?.NaoTemOleo && permissaoNaoTemOleo ? (
                    <Button
                      title="Desfazer Não Tem Óleo"
                      type="button"
                      disabled={isSubmitting}
                      onClick={() => desfazerNaoTemOleo()}
                      className={styles.button_sm}
                    />
                  ) : null}
                  <Button
                    title="Fechar"
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => closeModal()}
                    color={"secondary"}
                    className={styles.button_sm}
                  />
                </div>
                {isSubmitting && (
                  <div className={styles.loading_container}>
                    <Loading display={isSubmitting ? "block" : "none"} />
                  </div>
                )}
              </div>
            </Form>
          )
        }
      </Formik>
      <Modal
        open={openModalOleo}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModalOleo(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalNaoTemOleo
          idColeta={idColeta}
          closeModalAdicionarColeta={closeModal}
          responsavel={emissor}
          userId={dadosNovaColeta?.user_id}
          data={dadosNovaColeta?.data_pedido}
          nomeLocal={dadosColeta?.marca}
          idLocal={dadosColeta?.IDLocal}
          closeModal={() => setOpenModalOleo(false)}
        />
      </Modal>
    </div>
  );
}

export default AdicionarColeta;
